/**
 * The result overlay (unit convention §1). The model owns the store read, the
 * dismissal flag and the three actions; the View owns the reveal and the card.
 */
import React from 'react';

import {useResultOverlayModel} from './model';
import ResultOverlayView from './View';

export default React.memo(function ResultOverlay() {
  return <ResultOverlayView {...useResultOverlayModel()} />;
});
